import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/news";

export default function CategoryShowcase() {
  return (
    <section aria-label="内容频道" className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat) => {
          const count = articles.filter((a) => a.categorySlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative flex items-start gap-4 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors overflow-hidden"
            >
              <span
                className={`shrink-0 w-12 h-12 flex items-center justify-center rounded-md text-2xl ${
                  cat.accent === "primary"
                    ? "bg-primary-100 text-primary-700"
                    : cat.accent === "accent"
                    ? "bg-accent-100 text-accent-800"
                    : "bg-secondary-100 text-secondary-800"
                }`}
              >
                <i className={cat.icon}></i>
              </span>
              <span className="min-w-0 flex flex-col">
                <span className="flex items-center gap-2">
                  <span className="font-heading font-bold text-base text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-400">今日 {count} 条</span>
                </span>
                <span className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">{cat.desc}</span>
                <span className="mt-2.5 inline-flex items-center gap-1 text-xs text-primary-600">
                  进入频道
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}